export const setToCheckboxes = (predicate)=>{
    var _predicate_in;
    return predicate.nin != null ? {
        selected: predicate.nin,
        operator: 'exclude'
    } : {
        selected: (_predicate_in = predicate.in) !== null && _predicate_in !== void 0 ? _predicate_in : [],
        operator: 'include'
    };
};
export const checkboxesToSet = (next)=>next.operator === 'exclude' ? {
        nin: [
            ...next.selected
        ]
    } : {
        in: [
            ...next.selected
        ]
    };
export const nameSelectionHandler = (param)=>{
    let { current, predicate, onChange } = param;
    return (param)=>{
        let { selected } = param;
        if (selected == null) onChange(undefined);
        else if (selected === current) onChange(predicate);
        else onChange({
            exact: selected
        });
    };
};
export const dateRangeHandler = (onChange)=>{
    return (param)=>{
        let { selected, from, to } = param;
        if (selected !== 'range') return onChange(undefined);
        const next = {};
        if (from != null) next.gte = from;
        if (to != null) next.lte = to;
        onChange(next.gte == null && next.lte == null ? undefined : next);
    };
};
